import { EventEmitter, Injectable, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MySnackbarComponent } from "../components/my-snackbar/my-snackbar.component";
import { GTMSegmentService } from "../services/gtm-segment.service";
declare let analytics;
@Injectable({
  providedIn: "root",
})

export class MySnackBarService {
  @Output() ToastEvent = new EventEmitter();
  constructor(private snackBar: MatSnackBar, private GTMSegment: GTMSegmentService) { }
  public openSnackBar(message: string, action: string, css: string, snackType?: any) {
    this.ToastEvent.emit();
    this.GTMSegment.GTMPopupInitialization("ToastEvent", message);
    const _snackType: any = snackType !== undefined ? snackType : "Success";

    this.snackBar.openFromComponent(MySnackbarComponent, {
      duration: 5000,
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: [css],
      data: { message: message, snackType: _snackType },
    });
  }
}
